import { useContext } from 'react';
import invariant from 'invariant';
import { ToastContext } from "./ToastContext";
export var useToast = function useToast() {
  var context = useContext(ToastContext);
  invariant(context, 'Missing toast provider context. Make sure the corresponding provider is present.');
  return context;
};